import axios from '@plugins/axios';

class JuegoService {
    getList(juego_id = null, options = {}) {
        return axios({
            url: `sistema/juego/sorteo/${juego_id}`,
            method: 'GET',
            ...options
        });
    }
}

export const BaseJuegoService = JuegoService;

export default new JuegoService();